<p-panelMenu [model]="mobile_menu"> </p-panelMenu>
<div class="menu-footer" [class]="user?.role !== 'LD' ? 'mt-3' : null">
  <a href="mailto:mentoring@femmepalette.com" class="item">{{ 'MENU.CONTACT_US' | translate }}</a>
  <hr />
  <button (click)="this.signOut()" class="item p-button-text button-menu">{{ 'MENU.LOG_OUT' | translate }}</button>
</div>